import { createStore } from "vuex";

export default createStore({
  state: {
    currentSeriesList: [],
  },
  mutations: {
    StoreSeriesWindowing(state, series) {
      var matching = state.currentSeriesList.filter(
        (x) => x.seriesUID == series.seriesUID
      );

      if (matching.length > 0) {
        matching.forEach((x) => {
          x.ww = series.ww;
          x.wl = series.wl;
        });
      } else {
        state.currentSeriesList.push(series);
      }
    },
  },
  actions: {
    StoreSeriesWindowing({ commit }, series) {
      commit("StoreSeriesWindowing", series);
    },
  },
  getters: {
    GetSeries: (state) => (seriesUID) => {
      var matching = state.currentSeriesList.filter(
        (x) => x.seriesUID == seriesUID
      );

      if (matching.length > 0) return matching[0];
      else return undefined
    },
  },
  modules: {},
});
